// extracted by mini-css-extract-plugin
export var cardLayout = "_29-1";
export var paginationContainer = "_29-0";